import { Component, Prop, Vue } from "vue-property-decorator";
import { Checkbox, Radio, Tooltip } from "ant-design-vue";
import { MethodologyType } from "@/util/enum";
import { fmtMsg } from "commonui";
import { CommonLocale, ContentExposureLocale, MethodologyLocale } from "@/locales/localeid";

export interface MethodologyRadioGroupProps {
	isEdit?: boolean;
	isAnyEdit?: boolean;
	initValues?: any[];
	methodologySum?: any;
}

@Component({
	components: {
		Radio,
		RadioGroup: Radio.Group,
		Tooltip
	}
})
export default class MethodologyRadioGroup extends Vue {
	@Prop({ default: false }) isEdit!: boolean;
	@Prop({ default: false }) isAnyEdit!: boolean;
	@Prop({ default: () => [] }) initValues!: any;
	@Prop({
		default: () => ({
			classic: { sequence: 0, sum: 0 },
			remote: { sequence: 0, sum: 0 },
			digital: { sequence: 0, sum: 0 },
			independent: { sequence: 0, sum: 0 }
		})
	})
	methodologySums!: any;
	@Prop({ default: false }) showTooltip!: boolean; // to all disable tooltip permanently

	tooltipVisible = false; // for mouse over and leave
	locale = CommonLocale;

	$refs!: {
		content: HTMLDivElement;
	};

	get methodologyType() {
		return MethodologyType;
	}
	get methodologyLocale() {
		return MethodologyLocale;
	}
	get contentExposureLocale() {
		return ContentExposureLocale;
	}
	get showError() {
		return this.initValues.length === 0;
	}

	mounted() {
		const parent = this.$refs.content.parentNode as HTMLTableCellElement;
		if (parent) {
			parent.addEventListener("dblclick", this.onDoubleClick);
			parent.addEventListener("mouseenter", this.onMouseEnter);
			parent.addEventListener("mouseleave", this.onMouseLeave);
		}
	}

	beforeDestroy() {
		const parent = this.$refs.content.parentNode as HTMLTableCellElement;
		if (parent) {
			parent.removeEventListener("dblclick", this.onDoubleClick);
			parent.removeEventListener("mouseenter", this.onMouseEnter);
			parent.removeEventListener("mouseleave", this.onMouseLeave);
		}
	}

	onDoubleClick() {
		!this.isEdit && this.$emit("doubleClick");
	}

	onMouseEnter() {
		this.tooltipVisible = true;
	}

	onMouseLeave() {
		this.tooltipVisible = false;
	}

	showSum({ sequence, sum }) {
		return !(sequence === 0 || sum === 0);
	}
	getSumText({ sequence, sum }) {
		return `${sequence}/${sum}`;
	}
	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
}
